
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import "air-datepicker/dist/css/datepicker.min.css";
import { VMoney } from "v-money";
import debounce from 'lodash/debounce';

const $ = require("jquery");
window.$ = $;
window.jQuery = $;
require("air-datepicker");

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue"),
    Modal: () => import("@/components/Modal.vue"),
    RejectRequestModal: () => import("@/components/admin/RejectRequestModal.vue")
  },
  directives: { money: VMoney },
  filters: {
    date(value) {
      return value ? moment(value, "YYYY-MM-DD").format("LL") : "";
    },
    formatMoney(val, canFormat) {
      if (canFormat) {
        if (!val) return "";
        return String(val).formatMoney();
      }
      return val;
    }
  },
  computed: {
    noSystemTracks() {
      return (this as any).request.requests_tracks
        ? (this as any).request.requests_tracks.filter((rt: any) => !rt.system)
        : [];
    },
    systemTracks() {
      return (this as any).request.requests_tracks
        ? (this as any).request.requests_tracks.filter((rt: any) => rt.system)
        : [];
    }
  }
})
export default class Requests extends Vue {
  dictionary: any = {};
  companies: any = [];
  branches: any = [];
  currencies: any = [];
  statuses: any = [];
  title: string = "";
  comment: string = "";
  modalText: string = "Solicitud de capacidad adicional";
  statusText: string = "";
  request: any = {};
  rows: any = [];
  countries: any = [];
  rowsEndoso: any = [];
  locationData: any = {
    address: '' ,
    city: '',
    province: '',
    country: '',
    zipcode: '',
    coordinate_lat: 0,
    coordinate_lng: 0
  };
  autocomplete: any = null;

  money: any = {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: false
  };

  async mounted() {
    const _this = this;
    await this.loadDictionary();
    await this.loadCurrencies();
    await this.loadCompanies();
    await this.loadBranches();
    await this.loadStatuses();
    await this.loadRequest();
    await this.loadCountries();
    await this.initGoogleAutocomplete();
    await this.fillInAddress();

    this.generateTable("rows", this.request);
    setTimeout(() => {
      (this as any).$root.localizeDatepicker($);
      let datepicker = $(".dtpicker")
        .datepicker({
          language: "es",
          autoClose: true,
          onSelect: function onSelect(fd, date) {
            _this.updateColumn(this.key, moment(date).format("YYYY-MM-DD"));
          }
        })
        .data("datepicker");
    }, 1000);
  }

  initGoogleAutocomplete() {
    var options = {
      types: ['address'],
      componentRestrictions: {country: ["ar", "cl", "uy", "py"]}
    };

     this.autocomplete = new google.maps.places.Autocomplete(
       (this.$refs.autocomplete) as HTMLInputElement,
       options);
      this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
      this.autocomplete.addListener('place_changed', this.fillInAddress);
  }

   fillInAddress() {
      var place = this.autocomplete.getPlace();

      let requests_lat = !this.request.requests_details[0].coordinate_lat || this.request.requests_details[0].coordinate_lat == 0 ? -34.6177 : parseFloat(this.request.requests_details[0].coordinate_lat);
      let requests_lng = !this.request.requests_details[0].coordinate_lng || this.request.requests_details[0].coordinate_lng == 0 ? -58.3621 : parseFloat(this.request.requests_details[0].coordinate_lng);
      

       let markerPosition = {
          location: {
            lat: requests_lat,
            lng: requests_lng
          }
        }

      if(!this.request.requests_details[0].coordinate_lat || this.request.requests_details[0].coordinate_lat == 0) {
        var map = new google.maps.Map( document.getElementById("map"), {
              center: {lat:  requests_lat,lng: requests_lng },
              zoom: 3
            });
      } else {
        var map = new google.maps.Map( document.getElementById("map"), {
              center: {lat:  requests_lat,lng: requests_lng },
              zoom: 16
            });
            var marker = new google.maps.Marker({
          map: map,
          anchorPoint: new google.maps.Point(0, -29)
        });
          marker.setPosition(markerPosition.location);
          marker.setVisible(true);
      }
        if (!place)  return;
        var marker = new google.maps.Marker({
          map: map,
          anchorPoint: new google.maps.Point(0, -29)
        });
        
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17);
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);  
      
      
      this.locationData.address = place.address_components.find(e => e.types[0] === "route").long_name + ' ' + (place.address_components.find(e => e.types[0] === "street_number") ? place.address_components.find(e => e.types[0] === "street_number").long_name : "");
      this.locationData.country = place.address_components.find(e => e.types[0] === "country") ? place.address_components.find(e => e.types[0] === "country").long_name : "";
      this.locationData.province = place.address_components.find(e => e.types[0] === "administrative_area_level_1") ? place.address_components.find(e => e.types[0] === "administrative_area_level_1").long_name : "";    
      this.locationData.city = place.address_components.find(e => e.types[0] === "administrative_area_level_2") ? place.address_components.find(e => e.types[0] === "administrative_area_level_2").long_name : "";
      this.locationData.zipcode = place.address_components.find(e => e.types[0] === "postal_code") ? place.address_components.find(e => e.types[0] === "postal_code").long_name : "";   
      this.locationData.coordinate_lat = place.geometry.location.lat();      
      this.locationData.coordinate_lng = place.geometry.location.lng();
      this.habdleUpdateAddress();
  }

  
  async loadCurrencies() {
    const response: any = await (this.$root as any)._get("currencies/all");
    this.currencies = response.data;
  }

  async loadCompanies() {
    const response: any = await (this.$root as any)._post("companies/all");
    this.companies = response.data;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get("branches");
    this.branches = response.data;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data;
  }

  getCountry(id: string) {
    for (let i: number = 0; i < this.countries.length; i++) {
      if (parseInt(this.countries[i].id) === parseInt(id)) {
        return this.countries[i].title;
      }
    }
    return "";
  }

  habdleUpdateAddress() {
    let key = Object.keys(this.locationData);
    for(let i in key) {
        this.updateColumn(key[i], this.locationData[key[i]], false);      
    }
  }

  async updateColumn(col, value, money = false)  {
    let newValue = value;
    if (money) {
      newValue = value.replace(/\./g, "").replace(",", ".");
    }
    const _this = this;
    try {
      const response: any = await (_this.$root as any)._put(
        `requests/updatecolumn/${_this.request.id}`,
        { field: col, value: newValue }
      );
      if (response.status) {
        (_this.$root as any).notify("Campo modificado con éxito.");
      } else {
        (_this.$root as any).notify("No se pudo modificar el campo.", "error");
      }
    } catch (e) {
      (_this.$root as any).notify("No se pudo modificar el campo.", "error");
    }
  }

  debounceUpdateColum = debounce((col, value, money = false,event) => {
    console.log("Debounce",event);
    this.updateColumn(col,value,money);
  }
    ,1500);

  showModal(id: number) {
    (this.$refs[`modal${id}`] as any).show();
  }

  showRejectModal() {
    (this.$refs.rejectModal as any).show();
  }

  checkIfUpdate(rowKey, rowValue) {
    let newRowValue = rowValue.replace(/\./g, "").replace(",", ".");
    let notUpdate = false;
    if (this.request.requests_details[0][rowKey] == newRowValue || this.request.requests_details[0][rowKey] == rowValue ) {
      notUpdate = true
      return notUpdate;
    }
    return notUpdate;
  }

  modifyType(modifyType: number) {
    switch (modifyType) {
      case 0:
        return "Original";
      case 1:
        return "Endoso Sin Movimiento de Prima";
      case 2:
        return "Endoso Con Movimiento de Prima";
      case 3:
        return "Anulacion Parcial";
      case 4:
        return "Anulacion Total";
    }
    return "Original";
  }

  generateTable(key: string, request: any) {
    let editable = this.$store.state.user.type !== 2
    
    let parent: any = {
      company: {},
      branch: {},
      control_zone: {},
      subscriptor: {},
      currency: {},
      requests_details: [{}]
    };
    if (request.parent_request) {
      parent = request.parent_request;
    }
    this[key].push({
      input: false,
      type: "span",
      label: "Tipo",
      canFormatToMoney: false,
      eValue: request.parent_request ? this.modifyType(parent.modifyType) : "",
      value: this.modifyType(request.modifyType)
    });
    this[key].push({
      input: "select",
      key: "companyId",
      options: this.companies,
      type: "span",
      label: "Empresa",
      canFormatToMoney: false,
      eValue: parent.company.name,
      value: editable ? request.company.id : request.company.name
    });
    this[key].push({
      key: "validity_from",
      input: "date",
      type: "span",
      canFormatToMoney: false,
      label: this.dictionary.validity_from.label,
      eValue: parent.validity_from
        ? moment(parent.validity_from).format("DD/MM/YYYY")
        : "",
      value: request.validity_from
        ? moment(request.validity_from).format("DD/MM/YYYY")
        : ""
    });
    this[key].push({
      key: "validity_to",
      input: "date",
      type: "span",
      canFormatToMoney: false,
      label: this.dictionary.validity_to.label,
      eValue: parent.validity_to
        ? moment(parent.validity_to).format("DD/MM/YYYY")
        : "",
      value: request.validity_to
        ? moment(request.validity_to).format("DD/MM/YYYY")
        : ""
    });
    this[key].push({
      input: false,
      type: "span",
      label: "País",
      canFormatToMoney: false,
      eValue:
        parent.company && parent.company.country
          ? parent.company.country.title
          : "",
      value:
        request.company && request.company.country
          ? request.company.country.title
          : ""
    });
    this[key].push({
      input: "select",
      key: "branchId",
      options: (() => {
        const currentBranch = request.branch;
        const activeBranches = this.branches;
        if (currentBranch && !activeBranches.find((b: any) => b.id === currentBranch.id)) {
          return [{ ...currentBranch, title: `${currentBranch.title}` }, ...activeBranches];
        }
        return activeBranches;
      })(),
      type: "span",
      label: "Ramo",
      eValue: parent.branch.title,
      value: editable ? request.branch.id : request.branch.title,
      canFormatToMoney: false,
    });


    if (request.control_zone && parent.control_zone) {
      this[key].push({
        input: false,
        type: "span",
        label: "Zona de cúmulo",
        eValue: parent.control_zone.description,
        value: request.control_zone.description,
        canFormatToMoney: false,
      });
    }
    this[key].push({
      input: false,
      type: "span",
      label: "Subscriptor",
      eValue: parent.subscriptor.fullname,
      value: request.subscriptor.fullname,
      canFormatToMoney: false,
    });
    this[key].push({
      input: "select",
      key: "currencyId",
      options: this.currencies,
      type: "span",
      label: "Moneda",
      eValue: parent.currency.description,
      value: editable ? request.currency.id : request.currency.description,
      canFormatToMoney: false,
    });

    let order = [
      "total_sum_secured",
      "total_value_risks",
      "retained_sum",
      "aon_sum",
      "aon_sum_extra",
      "original_tax",
      "original_gross_bonus",
      "original_gross_aon",
      "commission",
      "taxation",
      "netpayment"
    ];

    let keys = Object.keys(request.requests_details[0]);
    keys.sort((a: string, b: string) => {
      const indexA: number = order.indexOf(a);
      const indexB: number = order.indexOf(b);
      return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
    });

    keys.forEach((index: any) => {
      if (
        [
          "id",
          "deletedAt",
          "requestId",
          "countryId",
          "validity_from",
          "validity_to",
          "coordinate_lat",
          "coordinate_lng",
          "country",
          "province",
          "city",
          "add",
          "address"

        ].indexOf(index) >= 0
      )
        return;
      let eValue = parent.requests_details[0][index];
      let value = request.requests_details[0][index];
      let type: any = "text";
      let options: any = [];

      let keyArr = [
        "createdAt",
        "updatedAt",
        "assignmentValidityAonTo",
        "assignmentValidityAonFrom"
      ];
      keyArr.forEach((key: any) => {
        if (index == key) {
          type = "date";
          value = value ? moment(value).format("DD/MM/YYYY") : "";
          eValue = eValue ? moment(eValue).format("DD/MM/YYYY") : "";
        }
      });


      if (index == "notes" || index == "risks") type = "textarea";
      if (index == "createdAt" || index == "updatedAt") type = false;

      if (typeof value === "boolean") {
        eValue = eValue !== undefined ? (eValue ? "Si" : "No") : "";
        value = value ? "Si" : "No";
      }

      if (!value) return;

      if (
        index == "special_aceptation" ||
        index === "excluded_from_contract" ||
        index === "coinsurance_participation"
      ) {
        type = "select";
        options = [{ id: 0, title: "No" }, { id: 1, title: "Si" }];
        value = value === "Si" ? 1 : 0;
       
      }

      let obj: any = {
        key: index,
        options,
        input: type,
        type: "span",
        label: this.dictionary[index] ? this.dictionary[index].label : "",
        eValue,
        value
      };

      let _this = this;
      if (index == "policy_number") {
        obj.type = "input";
        obj.name = "policy_number";
        obj.checkchanges = function($event) {
          _this.saveDetailField(index);
        };
        obj.canFormatToMoney = false;
      }

      keyArr = [
        "aon_sum",
        "aon_sum_extra",
        "facultative_sum",
        "original_gross_aon",
        "original_gross_bonus",
        "original_tax",
        "retained_sum",
        "total_sum_secured",
        "total_value_risks",
        "netpayment",
        "commission",
        "taxation"
      ];

      keyArr.forEach((key: any) => {
            if (index == key) obj.canFormatToMoney = index !== "original_tax";
            if (index === "original_tax") {
              obj.value = obj.value && obj.value.replace(".", ",");
              obj.eValue = obj.eValue && obj.eValue.replace(".", ",");
            }
          });

      if (index === "netpayment") {
        this[key].push({
          input: false,
          type: "span",
          label: "Prima neta de comisión",
          value:
            request.requests_details[0]["original_gross_aon"] -
            request.requests_details[0]["commission"],
          eValue:
            parent.requests_details[0]["original_gross_aon"] -
            parent.requests_details[0]["commission"],
          canFormatToMoney: true
        });
      }

      if (
        index === "taxation" &&
        request.company &&
        request.company.country.id === 1
      )
        return;

      if (
        index === "netpayment" &&
        request.company &&
        request.company.country.id === 1
      )
        return;

      this[key].push(obj);
    });
  }

  async saveDetailField(field) {
    let _this = this;
    let value = undefined;
    _this.rows.forEach(row => {
      if (row.name && row.name == field) value = row.value;
    });

    if (value !== undefined) {
      try {
        const response: any = await (_this.$root as any)._put(
          `requests/updatefield/${_this.request.id}`,
          { field: field, value: value }
        );
        if (response.status) {
          (_this.$root as any).notify("Campo modificado con éxito.");
        } else {
          (_this.$root as any).notify(
            "No se pudo modificar el campo.",
            "error"
          );
        }
      } catch (e) {
        (_this.$root as any).notify("No se pudo modificar el campo.", "error");
      }
    }
  }

  isEndoso() {
    return this.request.modifyType > 0;
  }

  exportPDF() {
    (document.querySelector("header.desktop") as any).style.display = "none";
    (document.querySelector(".footer") as any).style.display = "none";
    (document.querySelector("textarea") as any).style.display = "none";
    (document.querySelectorAll(".card-mobile") as any).forEach(ii => {
      ii.style.display = "none";
    });
    (document.querySelector(".cta") as any).style.display = "none";
    (document.querySelector(".menu-icon") as any).style.display = "none";
    (document.querySelector(".bell-icon") as any).style.display = "none";
    window.print();
    document.querySelector("header.desktop").removeAttribute("style");
    document.querySelector(".footer").removeAttribute("style");
    (document.querySelectorAll(".card-mobile") as any).forEach(ii => {
      ii.removeAttribute("style");
    });
    document.querySelector("textarea").removeAttribute("style");
    document.querySelector(".cta").removeAttribute("style");
    document.querySelector(".menu-icon").removeAttribute("style");
    document.querySelector(".bell-icon").removeAttribute("style");
  }

  async addNote() {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/addnote/${this.$route.params.id}`,
        {
          note: this.comment
        }
      );
      this.comment = "";
      await this.loadRequest();
      (this.$root as any).notify("Se agrego el comentario con éxito.");
    } catch (e) {
      (this.$root as any).notify("No se pudo agregar el comentario.", "error");
    }
  }

  async loadRequest() {
    const response: any = await (this.$root as any)._post(
      `requests/one/${this.$route.params.id}`,
      {
        models: "companies,branches,control_zones,subscriptors,currencies"
      }
    );
    this.request = response.data[0];   
    this.locationData.address =  response.data[0].requests_details[0].address;
    this.locationData.city =  response.data[0].requests_details[0].city;
    this.locationData.province =  response.data[0].requests_details[0].province;
    this.locationData.country =  response.data[0].requests_details[0].country;
    this.locationData.zipcode =  response.data[0].requests_details[0].zipcode;
    this.locationData.coordinate_lat =  response.data[0].requests_details[0].coordinate_lat;
    this.locationData.coordinate_lng =  response.data[0].requests_details[0].coordinate_lng;

    if ((this as any).isEndoso(this.request)) {
      this.title = `Procesar solicitud ${this.request.code}`;
    } else {
      this.title = "Detalle de solicitud";
    }
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get("requests/status");
    this.statuses = response;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }

  async approveRequest() {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/${this.$route.params.id}/changestatus/${this.statuses.indexOf(
          "Procesada"
        )}`
      );
      this.request.status = this.statuses.indexOf("Procesada");
      (this.$refs.modal1 as any).hide();
      this.statusText = `Solicitud de capacidad adicional procesada`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify("No se pudo procesar la solicitud.", "error");
    }
  }

  async rejectRequest(rejectionReasonId: number, comment: string) {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/${this.$route.params.id}/changestatus/${this.statuses.indexOf("No Procesada")}`,
        { rejectionReasonId, comment }
      );
      this.request.status = this.statuses.indexOf("No Procesada");
      (this.$refs.rejectModal as any).hide();
      this.statusText = `La solicitud de capacidad adicional cambió a estado No Procesada`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify("No se pudo cambiar de estado la solicitud.", "error");
    }
  }
}
